import PurchaseOrdersDropzone from './component';

export default PurchaseOrdersDropzone;
